import { memo, useEffect } from "react";
import { Form, InputGroup, OverlayTrigger } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";

/**
 * Component has been deprecated and should not be used anymore.
 * @deprecated Use components from shared/ui instead
 */
const FormInput = function FormInput({
  name,
  label = "",
  addon = "",
  text = "",
  displayAs = Form.Group,
  className = "",
  resetField = undefined,
  ...props
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    return () => resetField && resetField(name);
    //eslint-disable-next-line
  }, []);

  return (
    <Form.Group as={displayAs} className={className}>
      {label && <Form.Label>{label}</Form.Label>}
      <InputGroup hasValidation>
        {addon && <InputGroup.Text id={addon}>{addon}</InputGroup.Text>}
        <Controller
          name={name}
          render={() => (
            <Form.Control
              {...register(name)}
              isInvalid={!!errors[name]}
              {...props}
            />
          )}
        />
        <Form.Control.Feedback type="invalid">
          {errors[name]?.message.toString()}
        </Form.Control.Feedback>
      </InputGroup>
      {!errors[name] && text && <Form.Text>{text}</Form.Text>}
    </Form.Group>
  );
};

const WithPopover = function WithPopover({
  name,
  label = "",
  addon = "",
  text = "",
  popover,
  popoverPlacement = "top",
  displayAs = Form.Group,
  className = "",
  resetField = undefined,
  ...props
}) {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    return () => resetField && resetField(name);
    //eslint-disable-next-line
  }, []);

  return (
    <Form.Group as={displayAs} className={className}>
      <Form.Label>{label}</Form.Label>
      <OverlayTrigger
        overlay={popover}
        // @ts-ignore
        placement={popoverPlacement}
      >
        <InputGroup hasValidation>
          {addon && <InputGroup.Text id={addon}>{addon}</InputGroup.Text>}
          <Controller
            name={name}
            render={() => (
              <Form.Control
                {...register(name)}
                isInvalid={!!errors[name]}
                {...props}
              />
            )}
          />
          <Form.Control.Feedback type="invalid">
            {errors[name]?.message.toString()}
          </Form.Control.Feedback>
        </InputGroup>
      </OverlayTrigger>
      {!errors[name] && text && <Form.Text>{text}</Form.Text>}
    </Form.Group>
  );
};
FormInput.WithPopover = memo(WithPopover);
export default FormInput;
